import { styled } from '@mui/system';

export const FooterWrapper = styled('div')`
  background-color: rgba(255, 255, 255, 0.65);
  color: rgb(91 91 91);
  position: relative;
  text-align: center;
  padding: 16px 40px;
`;
